import styled from "styled-components";
import { disabledRoundBtnBg, disabledRoundBtnBorder, mobileChangeWidth, orangeColor2 } from "../../../styles/theme";

type CheckedState = {
  terms: boolean;
  privacy: boolean;
  location: boolean;
  marketing: boolean;
  email: boolean;
  sms: boolean;
};

export const Section = styled.div`
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-bottom: 8px;
  background: #fff;
  overflow: hidden;
`;

interface SectionHeaderProps {
  cursor?: string;
}

export const SectionHeader = styled.div<SectionHeaderProps>`
  display: flex;
  align-items: center;
  padding: 12px 20px;
  cursor: ${(props) => props.cursor ?? "pointer"};
  font-size: 18px;
  font-weight: 400;
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  margin-right: 12px;
  width: 20px;
  height: 20px;
`;

export const Arrow = styled.span<{ open: boolean }>`
  align-self: center;
  margin-left: auto;
  font-size: 1.5rem;
  transition: transform 0.2s;
  ${({ open }) => open && 'transform: rotate(180deg);'}
`;

export const SectionContent = styled.div<{ padding?: string, margin?: string, isNoBorder?: boolean }>`
  border-top: ${(props) => props.isNoBorder ? "none" : "1px solid #ddd"};
  max-height: 300px;
  overflow-y: auto;
  padding: ${(props) => props.padding ?? "20px 0"};
  margin: ${(props) => props.margin ?? "0 20px"};
  font-size: 14px;
  color: #777777;
  background: #fff;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: 10px;
  @media only screen and (max-width: ${mobileChangeWidth}) {
    font-size: 16px;
  }
`;

export const MarketingOptions = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 10px;
`;

export const InfoList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
  @media only screen and (max-width: ${mobileChangeWidth}) {
    align-items: flex-start;
  }
`;

export const InfoItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom:20px;
  word-break: break-all;
  @media only screen and (max-width: ${mobileChangeWidth}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Highlight = styled.span`
  display: inline-block;
  font-weight: 500;
  margin-right: 8px;
  width: 200px;
  align-self: center;
  @media only screen and (max-width: ${mobileChangeWidth}) {
    width: 100%;
  }
`;

export const InfoContent = styled.span`
  display: inline-block;
  width: 300px;
  align-self: center;
  @media only screen and (max-width: ${mobileChangeWidth}) {
    width: 100%;
  }
`;

interface RoundButtonProps {
  isDisabled?: boolean;
  fontSize?: string;
  borderRadius?: string;
  width?: string;
  height?: string;
  variant?: "filled" | "outlined"; // 추가
  changeFontSize?: string;
}

export const RoundButton = styled.button<RoundButtonProps>`
    flex-shrink: 0;
    align-self: stretch;
    box-sizing: border-box;
    background-color: ${(props) =>
        props.variant === "outlined"
            ? "#fff"
            : props.isDisabled
                ? `${disabledRoundBtnBg}`
                : `${orangeColor2}`};
    border: 1.5px solid
        ${(props) =>
        props.variant === "outlined"
            ? `${orangeColor2}`
            : props.isDisabled
                ? `${disabledRoundBtnBorder}`
                : `${orangeColor2}`};
    font-weight: 600;
    color: ${(props) =>
        props.variant === "outlined"
            ? `${orangeColor2}`
            : props.isDisabled
                ? `${disabledRoundBtnBorder}`
                : "#fff"};
    border-radius: ${(props) => props.borderRadius ?? "20px"};
    cursor: ${(props) => (props.isDisabled ? "not-allowed" : "pointer")};
    padding: 4px 16px;
    font-size: ${(props) => props.fontSize ?? "14px"};
    width: ${(props) => props.width ?? null};
    height: ${(props) => props.height ?? "40px"};
    transition: background 0.2s, color 0.2s;
    @media only screen and (max-width: ${mobileChangeWidth}) {
        font-size: ${(props) => props.changeFontSize};
    }
`;